import React from "react";
import { Translation } from "react-i18next";

const navigationConfig = [
  {
    id: "main",
    title: <Translation>{(t) => t("navigation.main.title")}</Translation>,
    type: "group",
    children: [
      // {
      //   id: "dashboard",
      //   title: (
      //     <Translation>{(t) => t("navigation.main.dashboard")}</Translation>
      //   ),
      //   type: "item",
      //   icon: "apps",
      //   url: "/",
      //   exact: true,
      // },
      // {
      //   id: "basic-information",
      //   key: "1",
      //   title: (
      //     <Translation>
      //       {(t) => t("navigation.main.basic_information")}
      //     </Translation>
      //   ),
      //   type: "collapse",
      //   icon: "info_outline",
      //   children: [
      //     {
      //       id: "bases",
      //       title: (
      //         <Translation>
      //           {(t) => t("navigation.main.define_edit_bases")}
      //         </Translation>
      //       ),
      //       type: "item",
      //       url: "/basic-information/bases",
      //       exact: true,
      //     },
      //     {
      //       id: "semesters",
      //       title: (
      //         <Translation>
      //           {(t) => t("navigation.main.define_edit_semesters")}
      //         </Translation>
      //       ),
      //       type: "item",
      //       url: "/basic-information/semesters",
      //       exact: true,
      //     },
      //     {
      //       id: "class-bells",
      //       title: (
      //         <Translation>
      //           {(t) => t("navigation.main.class_bells")}
      //         </Translation>
      //       ),
      //       type: "item",
      //       url: "/basic-information/class-bells",
      //       exact: true,
      //     },
      //     {
      //       id: "lessons",
      //       title: (
      //         <Translation>{(t) => t("navigation.main.lessons")}</Translation>
      //       ),
      //       type: "item",
      //       url: "/basic-information/lessons",
      //       exact: true,
      //     },
      //     {
      //       id: "system-roles",
      //       title: (
      //         <Translation>
      //           {(t) => t("navigation.main.system_roles")}
      //         </Translation>
      //       ),
      //       type: "item",
      //       url: "/basic-information/system-roles",
      //       exact: true,
      //     },
      //     {
      //       id: "define-type-score",
      //       title: (
      //         <Translation>
      //           {(t) => t("navigation.main.define_type_score")}
      //         </Translation>
      //       ),
      //       type: "item",
      //       url: "/basic-information/define-type-score",
      //       exact: true,
      //     },
      //     {
      //       id: "school-info",
      //       title: (
      //         <Translation>
      //           {(t) => t("navigation.main.school_information")}
      //         </Translation>
      //       ),
      //       type: "item",
      //       url: "/basic-information/school-info",
      //       exact: true,
      //     },
      //   ],
      // },
      // {
      //   id: "users",
      //   key: "2",
      //   title: <Translation>{(t) => t("navigation.main.users")}</Translation>,
      //   type: "collapse",
      //   icon: "people_alt",
      //   children: [
      //     {
      //       id: "users-staff",
      //       title: <Translation>{(t) => t("staff")}</Translation>,
      //       type: "item",
      //       url: "/users/staff",
      //       exact: true,
      //     },
      //     {
      //       id: "users-teacher",
      //       title: <Translation>{(t) => t("teacher")}</Translation>,
      //       type: "item",
      //       url: "/users/teacher",
      //       exact: true,
      //     },
      //     {
      //       id: "users-student",
      //       title: <Translation>{(t) => t("student")}</Translation>,
      //       type: "item",
      //       url: "/users/student",
      //       exact: true,
      //     },
      //     {
      //       id: "users-parent",
      //       title: <Translation>{(t) => t("parent")}</Translation>,
      //       type: "item",
      //       url: "/users/parent",
      //       exact: true,
      //     },
      //   ],
      // },
      // {
      //   id: "classes",
      //   key: "3",
      //   title: <Translation>{(t) => t("navigation.main.classes")}</Translation>,
      //   type: "collapse",
      //   icon: "class",
      //   children: [
      //     {
      //       id: "classes-list",
      //       title: (
      //         <Translation>
      //           {(t) => t("navigation.main.define_edit_class")}
      //         </Translation>
      //       ),
      //       type: "item",
      //       url: "/classes",
      //       exact: true,
      //     },
      //     {
      //       id: "assignment-lessons",
      //       title: (
      //         <Translation>
      //           {(t) => t("navigation.main.assignment_lessons_class")}
      //         </Translation>
      //       ),
      //       type: "item",
      //       url: "/classes/assignment-lessons",
      //       exact: true,
      //     },
      //     {
      //       id: "assignment-teachers",
      //       title: (
      //         <Translation>
      //           {(t) => t("navigation.main.assignment_teachers_class")}
      //         </Translation>
      //       ),
      //       type: "item",
      //       url: "/classes/assignment-teachers",
      //       exact: true,
      //     },
      //     {
      //       id: "assignment-students",
      //       title: (
      //         <Translation>
      //           {(t) => t("navigation.main.assignment_students_class")}
      //         </Translation>
      //       ),
      //       type: "item",
      //       url: "/classes/assignment-students",
      //       exact: true,
      //     },
      //     {
      //       id: "class-schedule",
      //       title: (
      //         <Translation>
      //           {(t) => t("navigation.main.determine_class_schedule")}
      //         </Translation>
      //       ),
      //       type: "item",
      //       url: "/classes/class-schedule",
      //       exact: true,
      //     },
      //   ],
      // },
      // {
      //   id: "workbook",
      //   key: "2",
      //   title: <Translation>{(t) => t("workbook")}</Translation>,
      //   type: "collapse",
      //   icon: "layers",
      //   children: [
      //     {
      //       id: "attendance",
      //       title: <Translation>{(t) => t("attendance")}</Translation>,
      //       type: "item",
      //       url: "/workbook/attendance",
      //       exact: true,
      //     },
      //   ],
      // },
      {
        id: "exams",
        key: "3",
        title: (
          <Translation>{(t) => t("navigation.main.online_exam")}</Translation>
        ),
        type: "collapse",
        icon: "list_alt",
        children: [
          {
            id: "exams-list",
            title: (
              <Translation>{(t) => t("navigation.main.exam_list")}</Translation>
            ),
            type: "item",
            url: "/exams",
            exact: true,
          },
          {
            id: "add-exam",
            title: (
              <Translation>
                {(t) => t("navigation.main.submit_new_exam")}
              </Translation>
            ),
            type: "item",
            url: "/exams/add-exam",
            exact: true,
          },

          {
            id: "exam-bank",
            key: "8",
            title: (
              <Translation>{(t) => t("navigation.main.exam_bank")}</Translation>
            ),
            isChild: true,
            type: "collapse",
            icon: "list",
            children: [
              {
                id: "exam-bank-exams",
                title: (
                  <Translation>
                    {(t) => t("navigation.main.exam_bank_list")}
                  </Translation>
                ),
                type: "item",
                url: "/exam-bank",
                exact: true,
              },
              {
                id: "add-exam-bank",
                title: (
                  <Translation>
                    {(t) => t("navigation.main.submit_new_exam_bank")}
                  </Translation>
                ),
                type: "item",
                url: "/exam-bank/add-exam",
                exact: true,
              },
              {
                id: "question-bank",
                title: (
                  <Translation>
                    {(t) => t("navigation.main.question_bank")}
                  </Translation>
                ),
                type: "item",
                url: "/question-bank",
                exact: true,
              },
            ],
          },
        ],
      },
      {
        id: "assignments",
        key: "4",
        title: (
          <Translation>{(t) => t("navigation.main.assignment")}</Translation>
        ),
        type: "collapse",
        icon: "list_alt",
        children: [
          {
            id: "assignments-list",
            title: (
              <Translation>
                {(t) => t("navigation.main.assignment_list")}
              </Translation>
            ),
            type: "item",
            url: "/assignments",
            exact: true,
          },
          {
            id: "add-assignment",
            title: (
              <Translation>
                {(t) => t("navigation.main.submit_new_assignment")}
              </Translation>
            ),
            type: "item",
            url: "/assignments/add-assignment",
            exact: true,
          },
        ],
      },
      {
        id: "user-report",
        key: "5",
        title: (
          <Translation>{(t) => t("navigation.main.user_report")}</Translation>
        ),
        type: "item",
        icon: "list_alt",
        url: "/reports",
        exact: true,
      },
      // {
      //   id: "konj",
      //   key: "4",
      //   title: (
      //     <Translation>
      //       {(t) => t("navigation.main.konj-connection")}
      //     </Translation>
      //   ),
      //   type: "collapse",
      //   icon: "list_alt",
      //   children: [
      //     {
      //       id: "connect-students",
      //       title: (
      //         <Translation>
      //           {(t) => t("navigation.main.connect-students-to-konj")}
      //         </Translation>
      //       ),
      //       type: "item",
      //       url: "/connect-konj?type=students",
      //       exact: true,
      //     },
      //     {
      //       id: "connect-teachers",
      //       title: (
      //         <Translation>
      //           {(t) => t("navigation.main.connect-teachers-to-konj")}
      //         </Translation>
      //       ),
      //       type: "item",
      //       url: "/connect-konj?type=teachers",
      //       exact: true,
      //     },
      //   ],
      // },
    ],
  },
];

export default navigationConfig;
